export const useStyles = () => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 48px)',
    gap: 2,
    justifyContent: 'center',
    '& img': {
      width: '100%',
      height: 'auto',
      cursor: 'pointer',
    },
  },
});
